// RimoID changed the account or ended the session (live event, dropped socket, refused handshake): refresh the token
// right away instead of waiting for the next API call. Success → the session user (rights) is replaced through
// setSessionHooks.refreshed and the screens re-render; failure → `lost` → the „Abgemeldet“ screen, which then waits for
// a click (the RimoID browser session may still be alive and would otherwise sign straight back in).
import { refreshSession } from '../api/client';
import { holdSignIn, session } from '../api/auth';

let running: Promise<boolean> | null = null;

/** One refresh for any number of simultaneous triggers; resolves true when the session is still valid. */
export function recheckSession(): Promise<boolean> {
  running ??= (async () => {
    holdSignIn(true);
    const ok = await refreshSession().catch(() => false);
    // Still signed in (new rights, or only the network failed): the next sign-in screen may start on its own again.
    if (ok || session.user) holdSignIn(false);
    return ok;
  })().finally(() => { running = null; });
  return running;
}
